import React, { useContext } from 'react';
import DesktopDevPageSide300x250 from '@wix/da-ads/pkg/adunits/anon/DesktopDevPageSide300x250';
import UserDesktopDevPageSide300x250 from '@wix/da-ads/pkg/adunits/user/DesktopDevPageSide300x250';
import DesktopDevPageSide300x250Atf from '@wix/da-ads/pkg/adunits/anon/DesktopDevPageSide300x250Atf';
import UserDesktopDevPageSide300x250Atf from '@wix/da-ads/pkg/adunits/user/DesktopDevPageSide300x250Atf';
import MobileDevPageSide300x250 from '@wix/da-ads/pkg/adunits/anon/MobileDevPageSide300x250';
import UserMobileDevPageSide300x250 from '@wix/da-ads/pkg/adunits/user/MobileDevPageSide300x250';
import ErrorBoundary from '../../../../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';
import UpsellWrapper from '../../../../Ads/UpsellWrapper';
import cn from 'classnames';
import s from './Ad.scss';
const Ad = ({ block , adSafety , deviation , adSafetyState  })=>{
    const isMobile = useContext(MobileContext);
    const showAd = useShouldRenderAdArea(adSafety, true);
    if (!showAd) {
        return null;
    }
    // Mobile only has BTF
    if (isMobile && block.contentType === 'ad_top') {
        return null;
    }
    if (block.contentType === 'ad_top') {
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "SidebarAdAtf"
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['atf-runner']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['atf-inner']
        }, /*#__PURE__*/ React.createElement(UpsellWrapper, {
            upsellType: "normal",
            unit: "DesktopDevPageSide300x250Atf"
        }, /*#__PURE__*/ React.createElement("div", {
            className: cn(s['atf-unit'])
        }, /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
            anon: DesktopDevPageSide300x250Atf,
            user: UserDesktopDevPageSide300x250Atf,
            safety: adSafety,
            safetyState: adSafetyState
        }))))));
    }
    if (block.contentType === 'ad_btf') {
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "SidebarAdBtf"
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['btf-runner']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['btf-inner']
        }, /*#__PURE__*/ React.createElement(UpsellWrapper, {
            upsellType: "normal",
            unit: "DesktopDevPageSide300x250",
            className: !isMobile && s['btf-sticky']
        }, /*#__PURE__*/ React.createElement("div", {
            className: cn(s['btf-unit'])
        }, !isMobile && /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
            anon: DesktopDevPageSide300x250,
            user: UserDesktopDevPageSide300x250,
            safety: adSafety,
            safetyState: adSafetyState
        }), isMobile && /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
            anon: MobileDevPageSide300x250,
            user: UserMobileDevPageSide300x250,
            safety: adSafety,
            safetyState: adSafetyState
        }))))));
    }
    return null;
};
Ad.displayName = 'Ad';
export default Ad;
